<template lang="pug">
section.subpage.payment.pb-5(ref="subpage")
  template(v-if="currentUser && currentUser.acl && currentUser.acl.billings && currentUser.acl.billings.get && (currentUser.role === 'admin' || currentUser.role === 'master')")
    h2.title
      span {{ page.title }}
    section.body
      b-form.readonly(@submit.prevent)
        b-container(fluid)
          template(v-if="!datum || !datum.isCreditcard")
            b-row
              b-col
                .text-danger カード情報が登録されていません
            b-row.mt-4
              b-col
                b-button.mr-3(variant="primary",v-b-modal.modal-edit)
                  span.ml-1 登録する

          template(v-if="datum && datum.isCreditcard")
            b-row
              b-col.pr-0(cols=8)
                b-form-group(label="カード番号",description="")
                  b-form-input(v-model="datum.number",type="text",disabled,readonly)
              b-col(cols=4)
                b-form-group(label="有効期限",,description="")
                  b-form-input(v-model="datum.exp",type="text",disabled,readonly)
            b-row.mt-3
              b-col
                b-button.mr-3(variant="primary",v-b-modal.modal-edit)
                  span.ml-1 変更する

    b-modal#modal-edit(hide-header,@show="initModal()")
      ValidationObserver(slim,ref="observer")
        b-form.text-left(@submit.prevent)
          b-container(fluid)
            b-row
              b-col
                b-form-group(label="カード番号",label-for="input-number",description="",required)
                  ValidationProvider(:rules="{ required: true, regex: /^[0-9]{15}(?:[0-9]{1})?$/ }",name="カード番号",v-slot="{ errors }")
                    b-form-input#input-number(v-model="number",type="text",autocomplete="cc-number",placeholder="カード番号を入力",@input="validateInput")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col
                b-form-group#input-exps(label="有効期限",label-for="input-exp-month",description="",required)
                  .form-inline
                    ValidationProvider#expMonth(ref="expMonth",rules="required",name="月",v-slot="{ errors }")
                      b-form-select#input-exp-month(v-model="expMonth",:options="options.months",autocomplete="cc-exp-month",placeholder="月",@input="validateInput",style="max-width:6rem")
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                    span.mx-2.text-muted 月
                    span.mx-3.text-muted /
                    span.mx-2 20
                    ValidationProvider#expYear(ref="expYear",:rules="{ required: true, regex: /^[2-9][0-9]$/ }",name="年",v-slot="{ errors }")
                      b-form-input#input-exp-year(v-model="expYear",type="number",:min="new Date().getFullYear()",autocomplete="cc-exp-year",placeholder="",@input="validateInput",style="max-width:6rem")
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                    span.mx-2.text-muted 年
            b-row
              b-col
                b-form-group#input-names(label="カード名義人",label-for="input-firstName",description="",required)
                  .form-inline
                    ValidationProvider#firstName(rules="required",name="名",v-slot="{ errors }")
                      b-form-input#input-firstName(v-model="firstName",type="text",autocomplete="cc-given-name",placeholder="名を入力",@input="validateInput")
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                    ValidationProvider#lastName.ml-3(rules="required",name="姓",v-slot="{ errors }")
                      b-form-input#input-lastName(v-model="lastName",type="text",autocomplete="cc-family-name",placeholder="姓を入力",@input="validateInput")
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col
                b-form-group(label="セキュリティコード",label-for="input-csc",description="",required)
                  ValidationProvider(:rules="{ required: true, regex: /^[0-9]{3,4}$/ }",name="セキュリティコード",v-slot="{ errors }")
                    b-form-input#input-csc(v-model="csc",type="text",autocomplete="cc-csc",placeholder="セキュリティコード",@input="validateInput",style="max-width:10rem")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

            b-row
              b-col
                input#tkn(ref="token",name="tkn",type="hidden")

      template(v-slot:modal-footer="{ ok, cancel }")
        b-button(variant="secondary",@click="$bvModal.hide('modal-edit')") キャンセル
        b-button(variant="primary",@click="onSave()",:disabled="!valid")
          span(v-if="!datum || !datum.isCreditcard") 登録する
          span(v-else) 変更する

  template(v-else)
    .text-center.my-5.py-5.text-danger 設定されている権限では本機能はご利用できません
</template>

<script>
import { getData, postData } from '../utils/api'

import { clone, optionsMonth } from '../utils/libs'

import dayjs from 'dayjs'

const BILLING_AID = process.env.VUE_APP_BILLING_AID

const page = {
  id: 'payment',
  title: 'お支払い方法の確認・変更'
}

export default {
  name: page.id,
  /*
  head () {
    return {
      script: [
        { src: 'https://credit.j-payment.co.jp/gateway/js/jquery.js' },
        { src: 'https://credit.j-payment.co.jp/gateway/js/CPToken.js' }
      ]
    }
  },
  */
  data () {
    return {
      mask: false,
      page: page,
      currentUser: null,
      datum: null,
      valid: false,
      options: {
        months: []
      },
      number: null,
      expMonth: null,
      expYear: null,
      firstName: null,
      lastName: null,
      csc: null,
      token: null
    }
  },
  watch: {
  },
  mounted () {
    this.options.months = optionsMonth()

    this.loadData()
  },
  methods: {
    async loadData () {
      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.loadData()
        }, 300)
        return
      }
      this.$set(this, 'currentUser', this.$root.currentUser)

      this.$parent.$refs.header.checkCondition()

      await getData(`/mycompany/creditcard`).then((datum) => {
        this.datum = clone(datum)
      }).catch((err) => {
        console.log(err)
      })
    },
    async validateInput () {
      this.valid = await this.$refs.observer.validate()

      if (this.expYear && this.expMonth) {
        const exp = dayjs(new Date(Number(this.expYear) + 2000, Number(this.expMonth) - 1, 1)).endOf('month')
        if (exp.diff(dayjs()) < 0) {
          if (this.$refs.expMonth.errors.length === 0 && this.$refs.expYear.errors.length === 0) {
            this.$refs.expMonth.errors.push('有効期限が正しくありません')
            // this.$refs.expYear.errors.push('')
          }
          this.valid = false
        }
      }
      return this.valid
    },
    initModal () {
      this.number = null
      this.expMonth = null
      this.expYear = null
      this.firstName = null
      this.lastName = null
      this.csc = null
      this.token = null
    },
    async onSave () {
      if (!this.valid) {
        return
      }
      if (this.$root.currentUser.role !== 'admin' && this.$root.currentUser.role !== 'master') {
        return
      }

      this.msgBoxConfirm('カード情報を保存しますか？', this.getToken)
    },
    getToken () {
      CPToken.TokenCreate({
        aid: BILLING_AID,
        cn: this.number,
        ed: `${this.expYear}${String(this.expMonth).padStart(2, '0')}`,
        fn: this.firstName,
        ln: this.lastName,
        cvv: this.csc
      }, this.callbackCreateToken)
    },
    callbackCreateToken (res, err) {
      if (res !== 'Success') {
        if (err) {
          this.msgBoxError(err)
        } else {
          this.msgBoxError('決済の処理に失敗しました')
        }
      } else {
        setTimeout(() => {
          this.doSave()
        }, 300)
      }
    },
    async doSave () {
      this.mask = true

      const datum = {
        number: this.number.slice(this.number.length - 4).padStart(this.number.length, '*'),
        exp: `${String(this.expMonth).padStart(2, '0')}/${Number(this.expYear) + 2000}`,
        name: `${this.firstName} ${this.lastName}`,
        token: this.$refs.token.value
        // csc: this.csc
      }

      let message = null

      try {
        await postData(`/mycompany/creditcard`, datum).then((json) => {
          this.loadData()
        }).catch((err) => {
          console.log(err)
          message = 'データの保存に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      } catch (e) {
        console.log(e)
        message = 'データの保存に失敗しました'
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message, () => {
          // this.$bvModal.hide('modal-edit')
        })
      } else {
        this.$forceUpdate()
        this.$bvModal.hide('modal-edit')
      }
    }
  }
}
</script>

<style scoped lang="stylus">
form.readonly
  .form-group >>> label:after
    content: ''
>>> #modal-edit
  #input-names
    #input-firstName
    #input-lastName
      width 12rem
</style>
